import React, { Fragment, useState, useEffect, useRef, useContext } from 'react';
import { useHistory } from 'react-router-dom'
import { Link } from "react-router-dom";
import classes from './Header.module.css';
import { Container, Nav, Navbar } from "react-bootstrap";
import GlobalContext from '../../context/GlobalContext';
import $ from 'jquery';


const Header = props => {

    const [toggle, setToggle] = useState(true);
    const overlay = useRef();
    const {token, setToken} = useContext(GlobalContext);
    const history = useHistory();

    useEffect(()=>{
        $(document).click(()=>{
            $('.'+classes.dropdownMenu).slideUp(0);
        })
    }, [])

    const Toggle = () => {
        if (toggle) {
            overlay.current.style.display = 'block';
        } else {
            overlay.current.style.display = 'none';
        }
        setToggle(!toggle);
    }

    const handleLogout = () => {
        localStorage.removeItem('jwt');
        setToken('');
        history.push('/');
    }

    const handleToggle = (e) => {
        e.nativeEvent.stopImmediatePropagation();
        $('.'+classes.dropdownMenu).slideToggle(0)
    }

    return (
        <Fragment>
            <Navbar expand="md">
                <Container>
                    <Navbar.Brand href="/">
                        <img alt='Logo' className={classes.logo} src="/tecmilenio_logo.png" width="200" height="61" />
                    </Navbar.Brand>
                    {
                        (!token)?
                        <>
                        <Navbar.Toggle aria-controls="none" id="header-toggle" onClick={Toggle}>
                            <div></div>
                            <div></div>
                            <div></div>
                        </Navbar.Toggle>
                        <Navbar.Collapse className={classes.header} id="basic-navbar-nav">
                            <Nav className="me-auto">
                                <Link to="/" className="nav-link">Inicio</Link>
                                <Link to="/faq" className="nav-link">Preguntas Frecuentes</Link>
                                <Link to="/about" className="nav-link">Acerca de</Link>
                                <Link to="/quiero-ser-mentor" className="nav-link">
                                    <span className={classes.button + " " + classes.mentorbutton}>Quiero ser mentor</span>
                                </Link>
                                {/* <a href='https://forms.gle/osKXM8esBT5hvkHT7' className="nav-link">
                                    <span className={classes.button + " " + classes.mentorbutton}>Quiero ser mentor</span>
                                </a> */}
                                <Link to="/login" className="nav-link">
                                    <span className={classes.button + " " + classes.loginbutton}>Iniciar sesión</span>
                                </Link>
                            </Nav>
                        </Navbar.Collapse>
                        </>
                        :
                        <>
                        <Nav className={"me-auto " + classes.desktopNav}>
                            <Link to="/mi-disponibilidad" className="nav-link">Mi disponibilidad</Link>
                            <Link to="/categorias" className="nav-link">Categorías</Link>
                            <Link to="/mis-mentorias" className="nav-link">Mis mentorías</Link>
                            <Link to="/recursos" className="nav-link">Recursos</Link>
                            <div>
                                <img alt='Perfil' className={classes.profileImg} src="/images/profile-default-image.jpg" width="50" onClick={handleToggle}/>
                                <div className={classes.dropdownMenu}>
                                    <Link to="/mi-perfil" className="nav-link">Mi perfil</Link>
                                    <Link to="/about" className="nav-link">Acerca del programa</Link>
                                    <Link to="/" className="nav-link" onClick={handleLogout}>Cerrar sesión</Link>
                                </div>
                            </div>
                        </Nav>
                        <div className={classes.mobileNav}>
                            <Navbar.Toggle aria-controls="none" id="header-toggle" onClick={Toggle}>
                                <div></div>
                                <div></div>
                                <div></div>
                            </Navbar.Toggle>
                            <Navbar.Collapse className={classes.header} id="basic-navbar-nav">
                                <Nav className="me-auto">
                                    <img alt='Perfil' className={classes.mobileProfileImg} src="/images/profile-default-image.jpg" width="90"/>
                                    <Link to="/mi-disponibilidad" className="nav-link" onClick={()=>{$('#header-toggle').click()}}>Mi disponibilidad</Link>
                                    <Link to="/categorias" className="nav-link" onClick={()=>{$('#header-toggle').click()}}>Categorías</Link>
                                    <Link to="/mis-mentorias" className="nav-link" onClick={()=>{$('#header-toggle').click()}}>Mis mentorías</Link>
                                    <Link to="/recursos" className="nav-link" onClick={()=>{$('#header-toggle').click()}}>Recursos</Link>
                                    <Link to="/" className="nav-link" onClick={()=>{handleLogout(); $('#header-toggle').click();}}>Cerrar sesión</Link>
                                </Nav>
                            </Navbar.Collapse>
                        </div>
                        </>
                    }
                </Container>
            </Navbar>
            <div className="overlay" ref={overlay}></div>
        </Fragment>
    )
};

export default Header;
